import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=6487f263&lang=pug&"
import script from "./Trigger.vue?vue&type=script&lang=js&"
export * from "./Trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6487f263')) {
      api.createRecord('6487f263', component.options)
    } else {
      api.reload('6487f263', component.options)
    }
    module.hot.accept("./Trigger.vue?vue&type=template&id=6487f263&lang=pug&", function () {
      api.rerender('6487f263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/Trigger.vue"
export default component.exports